import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core'
import {Locations, MapLoader} from './locations.types'
import {faChevronLeft} from '@fortawesome/pro-regular-svg-icons/faChevronLeft'
import {faChevronRight} from '@fortawesome/pro-regular-svg-icons/faChevronRight'
import {faMapMarkerAlt} from '@fortawesome/pro-solid-svg-icons/faMapMarkerAlt'
import {faStar} from '@fortawesome/pro-solid-svg-icons/faStar'

@Component({
  selector: 'cft-locations-map',
  templateUrl: './locations-map.component.html',
  styles: [':host { display: block }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationsMapComponent implements OnChanges {
  @Input() locations!: Locations
  @Input() labels!: {
    defaultLocation: string
    location: string
    associations: string
  }
  @Input() googleMapsApiKey!: string

  mapLoader?: MapLoader

  readonly leftIcon = faChevronLeft
  readonly rightIcon = faChevronRight
  readonly pinIcon = faMapMarkerAlt
  readonly associationsIcon = faStar

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.locations.currentValue) {
      //reload the map whenever "locations" change
      this.mapLoader = new MapLoader(this.locations, this.googleMapsApiKey)
    }
  }
}
